module.exports = __webpack_public_path__ + "img/92202.3a6419bf.svg";